<div class="container animated fadeInRight">
  <app-lfsa-card [innTemplate]="Articulos" [titulo]="'EMPRESAS'" [efecto]="true" [colapseName]="'Articulos'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #Articulos>
    <div class="row">
      <div [class]="'form-group col-md-8'">
        <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
          (keyup)="onQuickFilterChanged()" #quickFilter />
      </div>
      <div [class]="'form-group col-md-4'">
        <button class="btn btn-success btn-block" (click)="callModal()">Agregar</button>
      </div>
    </div>
    <br>
    <hr>
    <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
    <div *ngIf="!loading">
      <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
        No existen datos para la lista de Empresas.
      </div>
      <ag-grid-angular *ngIf="!listaVacia" #agGrid class=" {{empModulo.agGrid.class}}" 
        [ngStyle]="empModulo.agGrid.style" id="{{empModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents "
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)"
        [pagination]="true" [paginationPageSize]="empModulo.agGrid.paginacion">
      </ag-grid-angular>
    </div>
    <br>
  </ng-template>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/home-emp']" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
    </div>
  </div>
</div>
<br>

<!-- MODAL -->
<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Crear Empresa'" [idButton]="'abrirModal'" [idOpen]="'Modal'"
  [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <form [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('empresa')"
          [placeholder]="'Empresa'" formControlName="empresa" [label]="'Ingrese Empresa*'" [type]="'text'" [id]="'empresa'"
          >
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('codempresa')"
          [placeholder]="'Código Empresa'" formControlName="codempresa" [label]="'Código empresa*'" [type]="'text'"
          [id]="'codempresa'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-combo-box (change)='seleccionGrupoNew()' 
                [opcion]="'descripcion'" [idOpcion]="'grupoFabril'" [comboBox]="cmbGrupoColaborador" formControlName="grupofabril"
                [control]="formulario.get('grupofabril')" [label]="'Grupo Fabril'" [id]="'grupofabril'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formulario.invalid"
            (click)="agregarArticulo()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- MODAL -->
<app-lfsa-modal [innTemplate]="enviarModalEditar" [titulo]="'Editar Empresa'" [idButton]="'abrirModalEditar'" [idOpen]="'ModalEditar'"
  [idClose]="'cerrarModalEditar'"></app-lfsa-modal>
<ng-template #enviarModalEditar>
  <form [formGroup]="formularioEditar" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioEditar.get('empresa')"
          [placeholder]="'nombre de empresa'" formControlName="empresa" [label]="'Empresa*'" [type]="'text'"
          [id]="'empresa'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-combo-box (change)='seleccionGrupoEdit()' 
                [opcion]="'descripcion'" [idOpcion]="'grupoFabril'" [comboBox]="cmbGrupoColaborador" formControlName="grupofabril"
                [control]="formularioEditar.get('grupofabril')" [label]="'Grupo Fabril'" [id]="'grupofabril'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioEditar.invalid"
            (click)="editarArticulo()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>